import { render, staticRenderFns } from "./ImmoScout.vue?vue&type=template&id=4ce563f2&"
import script from "./ImmoScout.vue?vue&type=script&lang=js&"
export * from "./ImmoScout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports